module.exports = {"normal":"Hodor","elite":"Hodor","boss":"Hodor","finalboss":"Hodor","rare":"Hodor"};